<template>
  <div data-app>
    <div class="row mx-1 page_id_111">
      <p></p>
      <div class="col-md-12 row m-0 bg-white p-0">
        <div class="py-4 px-4 border_b_silver col-4">
          <span class="card-label font-weight-bolder Main_Blue"
            >CV Search
          </span>
        </div>
        <div class="py-4 px-4 border_b_silver col-8">
          <div class="col-md-12 row m-0 filter_by_ch p-0">
            <div
              class="count_applicant col text-end p-0"
              v-if="bulkActionArr.length != 0"
            >
              {{ bulkActionArr.length }} Applicant selected
            </div>
            <div class="col" v-if="bulkActionArr.length == 0"></div>
            
            <v-combobox
              v-model="stutas_val"
              class="b_form_slecet_search_save11"
              style="width: 190px; max-width: 300px"
              :items="jobs"
              label="Shortlist for"
            >
              <template>
                <v-chip
                  :key="JSON.stringify(data.item)"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  :disabled="data.disabled"
                  @click:close="data.parent.selectItem(data.item)"
                >
                  {{ data.item }}
                </v-chip>
              </template>
            </v-combobox>
            <button
              style="
                margin-left: 12px;
                width: 102px;
                height: 34px;
                border: 1px solid #35a2e5;
                border-radius: 8px;
                font-weight: 400;
                font-size: 13px;
                text-align: center;
                color: #35a2e5;
              "
              @click="bulkActionProceed(stutas_val)"
            >
              Apply Status
            </button>
          </div>
        </div>
        <v-card class="rounded-0">
          <div class="d-none" style="display: flex; justify-content: flex-end">
            <v-btn
              v-if="found !== null"
              class="
                btn btn-sm btn-danger
                font-weight-bold
                py-2
                px-3 px-xxl-5
                my-1
              "
              fab
              small
              @click="deleteSavedSearch()"
              :disabled="found == null ? true : false"
            >
              <v-icon dark>mdi-minus</v-icon>
            </v-btn>
          </div>
          <div class="p-4 search_cv_ch" v-if="canSearch">
            <div class="row">
              <div class="col-md-4">
                <v-combobox
                  v-model="desired_salary"
                  :items="desiredSalaryOptions"
                  label="Expected salary "
                  multiple
                  size="sm"
                  class="mt-3"
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :key="JSON.stringify(data.item)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </div>
              <div class="col-md-4">
                <v-combobox
                  v-model="job_function"
                  :items="jobFunctionsOptions"
                  label="Job Function "
                  multiple
                  size="sm"
                  class="mt-3"
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :key="JSON.stringify(data.item)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </div>
              <div class="col-md-4">
                <v-combobox
                  v-model="city"
                  :items="cityOptions"
                  label="Job Location "
                  multiple
                  size="sm"
                  class="mt-3"
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :key="JSON.stringify(data.item)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <v-combobox
                  v-model="job_shift"
                  :items="jobShiftOptions"
                  label="Job Type"
                  multiple
                  size="sm"
                  class="mt-3"
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :key="JSON.stringify(data.item)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </div>
              <div class="col-md-4">
                <v-combobox
                  v-model="career_level"
                  :items="careerLevelOptions"
                  label="Career Level"
                  multiple
                  size="sm"
                  class="mt-3"
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :key="JSON.stringify(data.item)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </div>
              <div class="col-md-4">
                <v-combobox
                  v-model="skill"
                  :items="skillsOptions"
                  label="Job Skills"
                  multiple
                  size="sm"
                  class="mt-3"
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :key="JSON.stringify(data.item)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </div>
            </div>
            <div class="col-10 row m-0 cv_search_slect_ch p-0 pt-4">
              <div class="col-3 p-0 d-flex">
                <v-card-actions class="p-0">
                  <v-btn
                    :disabled="submitting"
                    class="
                      custom-submit-button
                      btn_submit__ch btn_submit__ch_____
                    "
                    @click="search"
                    ><b-spinner small type="grow" v-if="submitting"></b-spinner>
                    <span>Search</span>
                  </v-btn>
                </v-card-actions>
                <v-card-actions class="p-0">
                  <v-btn
                    class="
                      custom-submit-button
                      btn_submit__ch btn_submit__ch_____
                    "
                    @click="reset_filter()"
                    >
                    <!-- <b-spinner small type="grow"></b-spinner> -->
                    <span>Clear</span>
                  </v-btn>
                </v-card-actions>
              </div>
              <div class="col-md-4 p-0">
                
                <v-combobox
                  v-model="saved_search_title"
                  class="b_form_slecet_search_save11____ __12  ___hide_back_label"
                  style="max-width: 300px"
                  :items="saved_search_titles"
                  label="Select Saved Searches"
                  v-on:change="
                    (e) => {
                      myFunc1(e);
                    }
                  "
                >
                  <template>
                    <v-chip
                      :key="JSON.stringify(data.item)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </div>
              <div class="col-md-5 py-0 pr-4"
                v-if="
                  city !== null ||
                  desired_salary !== null ||
                  job_function !== null ||
                  job_shift !== null ||
                  career_level !== null
                "
              >
                <div class="d-flex">
                  <v-text-field
                    v-model="search_title"
                    label="Search title"
                    class="b_form_slecet_search_save1 ___hide_back_label"
                    required
                  ></v-text-field>

                  <v-btn
                    class="btn btn-sm font-weight-bold btn_search_save1"
                    small
                    style="float: right"
                    :disabled="search_title !== '' ? false : true"
                    @click="saveSearch"
                  >
                    Save search
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </div>
      <div class="col-md-12 row p-0 m-0">
        <!-- /////////////////////////////////// -->
        <div data-app class="p-0">
          <div class="row mt-1 mx-0 new_list_st_by_ch">
            <div class="row m-0 col-8 py-0 pl-0" style="height: fit-content">
              <!-- //////////////////////////////////start -->
              <div
                class="col-md-4 row m-0 mt-4 pt-0 pr-0"
                v-for="(item, index) in data.filter((item) => item.user)"
                :key="index"
                :class="index == 0 || index % 3 == 0 ? 'pl-0' : ''"
              >
                <!-- {{index}} -->
                <div
                  class="col-md-12 row m-0 border-r-16 p-4"
                  :class="
                    detail1 && detail1.id === item.id
                      ? 'bg-info-new'
                      : 'bg-white' && detail2 && detail2.id === item.id
                      ? 'bg-info-new'
                      : 'bg-white' && detail3 && detail3.id === item.id
                      ? 'bg-info-new'
                      : 'bg-white' && detail4 && detail4.id === item.id
                      ? 'bg-info-new'
                      : 'bg-white'
                  "
                >
                  <div class="col-md-12 p-0">
                    <v-checkbox
                      class="p-0 m-0"
                      color="secondary"
                      hide-details
                      @change="bulkAction($event, item)"
                    ></v-checkbox>
                  </div>
                  <div class="col-md-4 p-0" style="position: relative">
                    <img
                      @error="onImageLoadFailure($event)"
                      :src="mediaUrl + item.profile_pic || ''"
                      alt="Profile Image"
                      id="img_profile"
                      style="width: 74px; height: 74px; border-radius: 50%"
                    />
                  </div>
                  <div class="col-md-8 p-0 filter_by_ch secend">
                    <v-combobox
                      :v-model="item.user_id == id && job_id"
                      class="b_form_slecet_search_save11"
                      style="max-width: 300px"
                      :items="jobs"
                      label="Shortlist for"
                      @change="shortList($event, item.user_id)"
                    >
                      <template>
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          :disabled="data.disabled"
                          @click:close="data.parent.selectItem(data.item)"
                        >
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </div>

                  <div class="col-md-12 p-0 mt-4">
                    <h4
                      class="mb-0"
                      style="color: #242424; font-size: 18px; font-weight: bold"
                    >
                      {{ item.user.name }}
                    </h4>
                  </div>
                  <div class="col-md-12 p-0">
                    <p
                      class=""
                      style="
                        width: fit-content;
                        border: 1px solid silver;
                        padding: 0px 2px 0px;
                        border-radius: 3px;
                        margin-right: 3px;
                        display: inline-block;
                        margin-bottom: 0 !important;
                        margin-top: 3px !important;
                      "
                      v-for="(_data, _index) in item.skills"
                      :key="_index"
                      :style="!_data.skill ? 'display: none !important;' : ''"
                      :class="_index > 4 ? 'd__none__' : ''"
                    >
                      <!-- <span
                        class="p-0"
                        v-if="_index > 0 && _index < item.skills.length && _data.skill"
                        >
                        ,
                        </span > -->
                      {{ _data.skill.text }}
                    </p>
                  </div>
                  <div class="col-md-12 p-0 py-2">
                    <div class="m-0" style="color: #666; font-size: 14px">
                      <h4
                        class="widget-title tooltipch mb-0 bold detail_heading"
                      >
                        <img
                          src="/images/job_page/Money_left.svg"
                          alt="..."
                          class="pr-2"
                        /><span class="tooltiptextch">Per month salary</span>
                      </h4>
                      {{ item.desired_salary }}
                      <span v-if="!item.desired_salary">N/A</span>
                    </div>
                  </div>
                  <div class="col-md-12 p-0 pb-2">
                    <div class="m-0" style="color: #666; font-size: 14px">
                      <h4
                        class="widget-title tooltipch mb-0 bold detail_heading"
                      >
                        <img
                          src="/images/job_page/Experience.svg"
                          alt="..."
                          class="pr-2"
                        /><span class="tooltiptextch">Experience</span>
                      </h4>
                      <span v-if="item.skills"
                        >{{ item.skills[0].experience }} + Years</span
                      >
                      <span v-if="!item.skills">N/A</span>
                    </div>
                  </div>
                  <div class="_btn_gridddd22 _btn_gridddd p-0 m-0">
                    <div class="p-0" @click="view_CV(item.cv_path)">
                      <button
                        type="button"
                        class="new_details_job_dashbord_list2"
                      >
                        <span class="v-btn__content">CV</span>
                      </button>
                    </div>
                    <div class="p-0" style="">
                      <button
                        type="button"
                        class="new_details_job_dashbord_list2"
                      >
                        <a
                          target="blank"
                          :href="
                            '/job-seeker-employability-profile/' + item.user_id
                          "
                        >
                          <span class="v-btn__content">Full Profile</span>
                        </a>
                      </button>
                    </div>
                    <div class="p-0" @click="singleDetail1(item)">
                      <button
                        type="button"
                        class="new_details_job_dashbord_list2"
                      >
                        Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ////////////////////////////////// -->
            </div>
            <div class="col-lg-4 p-0 sidbar_ch_new3" v-if="detail1">
              <div class="col-lg-12 pr-0 pt-4 pl-0">
                <div class="col-md-12 row m-0 p-0">
                  <div class="col-md-12 row m-0 border-t-lr-16 bg-info-new p-4">
                    <div class="col-md-12 p-0 text-end">
                      <button
                        class="badge badge-danger badge-pill"
                        @click="(detail1 = false), (alwyes = true)"
                      >
                        X
                      </button>
                    </div>
                    <div class="col-md-4 p-0" style="position: relative">
                      <img
                        @error="onImageLoadFailure($event)"
                        :src="mediaUrl + detail1.profile_pic || ''"
                        alt="Profile Image"
                        style="width: 74px; height: 74px; border-radius: 50%"
                      />
                    </div>
                    <div class="col-md-8 p-0 filter_by_ch secend">
                      <v-combobox
                        :v-model="detail1.user_id == id && job_id"
                        class="b_form_slecet_search_save11"
                        style="max-width: 300px"
                        :items="jobs"
                        label="Shortlist for"
                        @change="shortList($event, detail1.user_id)"
                      >
                        <template>
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            :disabled="data.disabled"
                            @click:close="data.parent.selectItem(data.item)"
                          >
                            {{ data.item }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </div>
                    <div class="col-md-12 p-0 mt-4">
                      <h4
                        class="mb-0"
                        style="
                          color: #242424;
                          font-size: 18px;
                          font-weight: bold;
                        "
                      >
                        {{ detail1.user.name }}
                      </h4>
                    </div>
                    <div class="col-md-12 p-0">
                      <p
                        class=""
                        style="
                          width: fit-content;
                          border: 1px solid silver;
                          padding: 3px 4px 4px;
                          border-radius: 3px;
                          margin-right: 3px;
                          display: inline-block;
                          margin-bottom: 0 !important;
                          margin-top: 3px !important;
                        "
                        v-for="(_data, _index) in detail1.skills"
                        :key="_index"
                        :style="!_data.skill ? 'display: none !important;' : ''"
                      >
                        <!-- <span
                        class="p-0"
                        v-if="_index > 0 && _index < detail1.skills.length && _data.skill"
                        >
                        ,
                        </span > -->
                        {{ _data.skill.text }}
                      </p>
                    </div>
                    <div class="col-md-12 p-0 py-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Money_left.svg"
                            alt="..."
                            class="pr-2"
                          /><span class="tooltiptextch">Per month salary</span>
                        </h4>
                        {{ detail1.desired_salary }}
                        <span v-if="!detail1.desired_salary">N/A</span>
                      </div>
                    </div>
                    <div class="col-md-12 p-0 pb-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Experience.svg"
                            alt="..."
                            class="pr-2"
                          /><span class="tooltiptextch">Experience</span>
                        </h4>
                        <span v-if="detail1.skills"
                          >{{ detail1.skills[0].experience }} + Years</span
                        >
                        <span v-if="!detail1.skills">N/A</span>
                      </div>
                    </div>
                    <hr
                      class="col-md-12 p-0 mt-3"
                      style="background: rgba(53, 162, 229, 0.25)"
                    />
                    <div class="_btn_gridddd22_2 _btn_gridddd p-0 m-0">
                      <div class="p-0" @click="view_CV(detail1.cv_path)">
                        <button
                          type="button"
                          class="new_details_job_dashbord_list2"
                        >
                          <span class="v-btn__content">View CV</span>
                        </button>
                      </div>
                      <div class="p-0" style="">
                        <button
                          type="button"
                          class="new_details_job_dashbord_list2"
                        >
                          <a
                            target="blank"
                            :href="
                              '/job-seeker-employability-profile/' +
                              detail1.user_id
                            "
                          >
                            <span class="v-btn__content"
                              >View Full Profile</span
                            >
                          </a>
                        </button>
                      </div>
                     
                    </div>
                    <hr
                      class="col-md-12 p-0 mt-3"
                      style="background: rgba(53, 162, 229, 0.25)"
                    />
                    <div
                      class="
                        mb-3
                        mt-0
                        mx-0
                        p-0
                        col-md-12
                        d-flex
                        justify-content-center
                      "
                      style="gap: 5px"
                    >
                      <div class="p-0">
                        <button
                          v-on:click="singleDetail11(detail1)"
                          type="button"
                          class="
                            btn_dash_ch__
                            btn_span_ch
                            new_details_job_dashbord_list
                          "
                        >
                          <img
                            class="dashbord25"
                            src="\images/job_application/Video_icon_.svg"
                            alt=""
                            width="25"
                            height="25"
                          />
                          <div class="light_frozi">Video</div>
                        </button>
                      </div>
                      <div class="p-0">
                        <button
                          v-on:click="singleDetail22(detail1)"
                          type="button"
                          class="
                            btn_dash_ch__
                            btn_span_ch
                            new_details_job_dashbord_list
                          "
                        >
                          <img
                            class="dashbord25"
                            src="\images/job_application/Audio_icon_normal.svg"
                            alt=""
                            width="25"
                            height="25"
                          />
                          <div class="light_frozi">Audio</div>
                        </button>
                      </div>
                      
                    </div>
                    <hr
                      class="col-md-12 p-0"
                      style="background: rgba(53, 162, 229, 0.25)"
                    />
                  </div>
                </div>
                <div
                  class="
                    col-md-12
                    forvideoFullW
                    row
                    m-0
                    border-b-lr-16
                    bg-info-new
                    pt-0
                    pb-4
                  "
                >
                  <h5
                    class="p-0 mb-4"
                    style="
                      font-size: 26px;
                      color: #005696 !important;
                      font-weight: bold;
                    "
                  >
                    Video introduction
                  </h5>
                  <video-player
                    class="video-player-box p-0 video_by_ch video_by_ch2"
                    ref="videoPlayer"
                    :options="detail1.videoPlayer"
                    :playsinline="true"
                    customEventName="customstatechangedeventname"
                  >
                  </video-player>
                </div>
              </div>
            </div>
            <div class="col-lg-4 p-0 sidbar_ch_new3" v-if="detail2">
              <div class="col-lg-12 pl-0 pt-4 pr-0">
                <div class="col-md-12 row m-0 p-0">
                  <div class="col-md-12 row m-0 border-t-lr-16 bg-info-new p-4">
                    <div class="col-md-12 p-0 text-end">
                      <button
                        class="badge badge-danger badge-pill"
                        @click="(detail2 = false), (alwyes = true)"
                      >
                        X
                      </button>
                    </div>
                    <div class="col-md-4 p-0" style="position: relative">
                      <img
                        @error="onImageLoadFailure($event)"
                        :src="mediaUrl + detail2.profile_pic || ''"
                        alt="Profile Image"
                        style="width: 74px; height: 74px; border-radius: 50%"
                      />
                    </div>
                    <div class="col-md-8 p-0 filter_by_ch secend">
                      <v-combobox
                        :v-model="detail2.user_id == id && job_id"
                        class="b_form_slecet_search_save11"
                        style="max-width: 300px"
                        :items="jobs"
                        label="Shortlist for"
                        @change="shortList($event, detail2.user_id)"
                      >
                        <template>
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            :disabled="data.disabled"
                            @click:close="data.parent.selectItem(data.item)"
                          >
                            {{ data.item }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </div>
                    <div class="col-md-12 p-0 mt-4">
                      <h4
                        class="mb-0"
                        style="
                          color: #242424;
                          font-size: 18px;
                          font-weight: bold;
                        "
                      >
                        {{ detail2.user.name }}
                      </h4>
                    </div>
                    <div class="col-md-12 p-0">
                      <p
                        class=""
                        style="
                          width: fit-content;
                          border: 1px solid silver;
                          padding: 3px 4px 4px;
                          border-radius: 3px;
                          margin-right: 3px;
                          display: inline-block;
                          margin-bottom: 0 !important;
                          margin-top: 3px !important;
                        "
                        v-for="(_data, _index) in detail2.skills"
                        :key="_index"
                        :style="!_data.skill ? 'display: none !important;' : ''"
                      >
                        
                        {{ _data.skill.text }}
                      </p>
                    </div>
                    <div class="col-md-12 p-0 py-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Money_left.svg"
                            alt="..."
                            class="pr-2"
                          /><span class="tooltiptextch">Per month salary</span>
                        </h4>
                        {{ detail2.desired_salary }}
                        <span v-if="!detail2.desired_salary">N/A</span>
                      </div>
                    </div>
                    <div class="col-md-12 p-0 pb-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Experience.svg"
                            alt="..."
                            class="pr-2"
                          /><span class="tooltiptextch">Experience</span>
                        </h4>
                        <span v-if="detail2.skills"
                          >{{ detail2.skills[0].experience }} + Years</span
                        >
                        <span v-if="!detail2.skills">N/A</span>
                      </div>
                    </div>
                    <hr
                      class="col-md-12 p-0 mt-3"
                      style="background: rgba(53, 162, 229, 0.25)"
                    />
                    <div class="_btn_gridddd22_2 _btn_gridddd p-0 m-0">
                      <div class="p-0" @click="view_CV(detail2.cv_path)">
                        <button
                          type="button"
                          class="new_details_job_dashbord_list2"
                        >
                          <span class="v-btn__content">View CV</span>
                        </button>
                      </div>
                      <div class="p-0" style="">
                        <button
                          type="button"
                          class="new_details_job_dashbord_list2"
                        >
                          <a
                            target="blank"
                            :href="
                              '/job-seeker-employability-profile/' +
                              detail2.user_id
                            "
                          >
                            <span class="v-btn__content"
                              >View Full Profile</span
                            >
                          </a>
                        </button>
                      </div>
                      
                    </div>
                    <hr
                      class="col-md-12 p-0 mt-3"
                      style="background: rgba(53, 162, 229, 0.25)"
                    />
                    <div
                      class="
                        mb-3
                        mt-0
                        mx-0
                        p-0
                        col-md-12
                        d-flex
                        justify-content-center
                      "
                      style="gap: 5px"
                    >
                      <div class="p-0">
                        <button
                          v-on:click="singleDetail11(detail2)"
                          type="button"
                          class="
                            btn_dash_ch__
                            btn_span_ch
                            new_details_job_dashbord_list
                          "
                        >
                          <img
                            class="dashbord25"
                            src="\images/job_application/Video_icon_.svg"
                            alt=""
                            width="25"
                            height="25"
                          />
                          <div class="light_frozi">Video</div>
                        </button>
                      </div>
                      <div class="p-0">
                        <button
                          v-on:click="singleDetail22(detail2)"
                          type="button"
                          class="
                            btn_dash_ch__
                            btn_span_ch
                            new_details_job_dashbord_list
                          "
                        >
                          <img
                            class="dashbord25"
                            src="\images/job_application/Audio_icon_normal.svg"
                            alt=""
                            width="25"
                            height="25"
                          />
                          <div class="light_frozi">Audio</div>
                        </button>
                      </div>
                     
                    </div>
                    <hr
                      class="col-md-12 p-0"
                      style="background: rgba(53, 162, 229, 0.25)"
                    />
                  </div>
                </div>
                <div
                  class="
                    col-md-12
                    forvideoFullW
                    row
                    m-0
                    border-b-lr-16
                    bg-info-new
                    pt-0
                    pb-4
                  "
                >
                  <h5
                    class="p-0 mb-4"
                    style="
                      font-size: 26px;
                      color: #005696 !important;
                      font-weight: bold;
                    "
                  >
                    Audio introduction
                  </h5>
                  <video-player
                    class="video-player-box video_by_ch2 p-0"
                    ref="videoPlayer1"
                    :options="detail2.videoPlayer1"
                    :playsinline="true"
                    customEventName="customstatechangedeventname"
                  >
                  </video-player>
                </div>
              </div>
            </div>
            
            <div class="col-lg-4 p-0 alwyes" v-if="alwyes">
              <div class="col-lg-12 pl-0 pr-0 pt-4">
                <div class="card sidebar">
                  <div class="card-body widget cardbodych" style="">
                    <h5
                      class=""
                      style="
                        font-style: normal;
                        font-weight: 700 !important;
                        font-size: 30px;
                        line-height: 120%;
                        color: #005696;
                      "
                    >
          Advertise with  <br />
          job4u.pk
          </h5>
        </div>
        <div class="col-12">
          <p
            style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 140%;
                        color: #666666;
                        background: transparent !important;
                      "
          >
          Contact us to display your
          Ad here to reach tens of
          thousands of people!

          </p>
                    <button
                      style="
                        padding: 12px 16px;
                        gap: 8px;
                        background: #35a2e5;
                        border-radius: 53px;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 140%;
                        color: #ffffff;
                      "
                    >
                    <img
              class="dashbord123"
              src="\images/job_application/Call.svg"
              alt=""
              style="margin-right: 10px"
            />
              Contact Sales
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
import Swal from "sweetalert2";
import GeneralService from "@/MainServices/GeneralService.js";

export default {
  data() {
    return {
      canSearch: true,
      mediaUrl: MEDIA_URL,
      submitting: false,
      loading: true,
      success: false,
      token: `Bearer ${localStorage.getItem("token")}`,
      valid: true,
      createForm: false,
      updateForm: false,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      headers: [
        { text: "Job Title", value: "job_title" },
        { text: "City", value: "location_city" },
        { text: "Salary Min.", value: "salary_min" },
        { text: "Salary Max.", value: "salary_max" },
        { text: "Job Type", value: "job_type" },
        { text: "Job Function", value: "job_function" },
        { text: "Experience", value: "experience" },
        { text: "Education", value: "education" },
        { text: "Gender", value: "gender" },
        { text: "No. of Vacancies", value: "no_of_vacancies" },
        { text: "Expire at", value: "apply_by" },
        { text: "Status", value: "status" },
        { text: "Block", value: "block" },
        { text: "Short List", value: "action" },
      ],
      city: null,
      cityOptions: [],
      desired_salary: null,
      desiredSalaryOptions: [
        "Upto 20,000",
        "20,001 - 40,000",
        "40,001 - 60,000",
        "60,001 - 80,000",
        "80,001 - 100,000",
        "100,001 - 125,000",
        "125,001 - 150,000",
        "150,001 - 175,000",
        "175,001 - 225,000",
        "225,001 - 275,000",
        "275,001 - 300,000",
        "300,000 - 350,000",
        "350,000 +",
      ],
      job_function: null,
      jobFunctionsOptions: [],
      job_shift: null,
      jobShiftOptions: [],
      career_level: null,
      careerLevelOptions: [],
      data: [],
      skill: null,
      skillsOptions: [],
      id: null,
      job_id: null,
      jobs: [],
      bulkActionArr: [],
      stutas_val: "",
      search_title: "",
      saved_search_titles: [],
      saved_search_title: "",
      found: null,
      detail1: null,
      detail2: null,
      detail3: null,
      detail4: null,
      alwyes: true,
    };
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    this.fetchStates();
    this.fetchJobFunctions();
    this.fetchCities();
    this.search();
    this.fetchJobShifts();
    this.fetchCareerLevels();
    this.fetchSkills();
    this.fetchCurrentJobs();
    this.fetchSavedSearches();
  },
  methods: {
    fetchStates() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/states`)
        .then((res) => {
          res.data.forEach((element) => {
            this.statesOptions.push({
              value: element.id,
              text: element.state_name,
            });
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchJobFunctions() {
      GeneralService.getJobFunctions()
        .then((_res) => {
          _res.data.forEach((element) => {
            this.jobFunctionsOptions.push(element.job_function_name);
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchCities() {
      GeneralService.getCities()
        .then((_res) => {
          _res.data.forEach((element) => {
            this.cityOptions.push(element.city_name);
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchJobShifts() {
      GeneralService.getJobShifts()
        .then((_res) => {
          _res.data.forEach((element) => {
            this.jobShiftOptions.push(element.job_shift);
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchCareerLevels() {
      GeneralService.getJobCareerLevels()
        .then((_res) => {
          _res.data.forEach((element) => {
            this.careerLevelOptions.push(element.career_level);
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchSkills() {
      GeneralService.getSkills()
        .then((_res) => {
          _res.data.forEach((element) => {
            _res.data.forEach((element) => {
              this.skillsOptions.push(element.skill_name);
            });
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    search() {
      var payload = {
        city: this.city,
        desired_salary: this.desired_salary,
        job_function: this.job_function,
        job_shift: this.job_shift,
        career_level: this.career_level,
        skills: this.skill,
      };
      axios.defaults.headers.common["Authorization"] = this.token;
      axios.post(`${API_URL}/search-cv`, payload).then((res) => {
        var temp = [];
        res.data.forEach((element) => {
          element.videoPlayer = {
            // videojs options
            muted: true,
            language: "en",
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            sources: [
              {
                type: "video/mp4",
                src: this.mediaUrl + "videos/raw/" + element.intro_video,
              },
            ],
            poster: "/static/images/author.jpg",
          };
          element.videoPlayer1 = {
            // videojs options
            muted: true,
            language: "en",
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            sources: [
              {
                type: "audio/wav",
                src: this.mediaUrl + "videos/raw/" + element.intro_audio,
              },
            ],
            poster: "/static/images/author.jpg",
          };
          temp.push(element);
        });
        this.data = temp;
      });
    },
    fetchCurrentJobs() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/jobs`)
        .then((res) => {
          res.data.forEach((element) => {
            this.jobs.push({
              value: element.id,
              text: element.job_title,
            });
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    makeToast(variant = null) {
      this.$bvToast.toast("Toast body content", {
        title: `Variant ${variant || "default"}`,
        variant: variant,
        solid: true,
      });
    },
    bulkAction(event, item_) {
      var newArr = this.bulkActionArr;
      var id = item_.user_id;
      if (event == true) {
        newArr.push(id);
        this.bulkActionArr = newArr;
      } else {
        newArr = this.bulkActionArr.filter((item) => {
          return item !== id;
        });
        this.bulkActionArr = newArr;
      }
    },

    bulkActionProceed(val) {
      if (val !== "All") {
        axios.defaults.headers.common["Authorization"] = this.token;
        axios
        .post(`${API_URL}/short-list-bulk-action-proceed`,{
          ids: this.bulkActionArr,
          jobid : val.value,
        })
          .then((res) => {
            Swal.fire({
              title: "",
              text: res.data.msg,
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
            this.getInititalData();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    shortList(job_id, user_id) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/short-list/${user_id}/${job_id.value}`)
        .then((res) => {
          Swal.fire({
            title: res.data.msg,
            text: "",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },

    saveSearch() {
      var payload = {
        city: this.city,
        desired_salary: this.desired_salary,
        job_function: this.job_function,
        job_shift: this.job_shift,
        career_level: this.career_level,
        skills: this.skill,
      };
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/save-search`, {
          search_title: this.search_title,
          payload: payload,
        })
        .then((res) => {
          this.$bvToast.toast(res.data.msg, {
            title: `Message`,
            variant: `success`,
            solid: true,
          });
          this.fetchSavedSearches();
        });
    },

    fetchSavedSearches() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/save-search`)
        .then((res) => {
          this.all_saved_search_titles = res.data;
          res.data.forEach((element) => {
            this.saved_search_titles.push({
              value: element.id,
              text: element.search_title,
            });
          });
          this.saved_search_titles.unshift(
            // ...[{ value: null, text: "Select saved searches" }]
          );

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    myFunc1(value) {
      this.found = value;
      var found;
      this.all_saved_search_titles &&
        this.all_saved_search_titles.forEach((element) => {
          if (element.id == value.value) {
            found = element.search_data;
          }
        });
      this.career_level = found.career_level;
      this.city = found.city;
      this.desired_salary = found.desired_salary;
      this.job_function = found.job_function;
      this.job_shift = found.job_shift;
      this.skills = found.skills;

      this.search();
    },

    reset() {
      this.saved_search_titles = this.job_function = null;
      this.jobFunctionsOptions = [];
      this.job_shift = null;
      this.jobShiftOptions = [];
      this.career_level = null;
      this.careerLevelOptions = [];
      this.data = [];
      this.skill = null;
      this.skillsOptions = [];
      this.id = null;
      this.job_id = null;
      this.jobs = [];
      this.city = null;
      this.search_title = "";
      this.saved_search_titles = [];
      this.saved_search_title = "";
      this.found = null;
    },
    reset_filter() {
      this.desired_salary = null;
      this.job_function = null;
      this.city = null;
      this.job_shift = null;
      this.career_level = null;
      this.skill = null;
      this.saved_search_title = null;
      this.search();
    },
    singleDetail1(item) {
      this.detail1 = item;
      this.detail2 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail11(item) {
      this.detail1 = item;
      this.detail2 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail2(item) {
      this.detail2 = item;
      this.detail1 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail22(item) {
      this.detail2 = item;
      this.detail1 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail3(item) {
      this.detail3 = item;
      this.getConversation(item);
      this.detail2 = false;
      this.detail1 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail4(item) {
      this.detail4 = item;
      this.detail2 = false;
      this.detail3 = false;
      this.detail1 = false;
      this.alwyes = false;
    },
    view_CV(path) {
      if (path) {
        //docs.google.com/gview?url=https://api.job4u.pk/public/storage/cvs/2L4ZDNuKi22C8UnqzjGIbavJEGhw8k961J5qeQ0g.pdf&embedded=true
        https: window.open(
          "https://docs.google.com/gview?url=" +
            this.mediaUrl +
            path +
            "&embedded=true",
          "_blank"
        );
      } else {
        Swal.fire({
          title: "",
          text: "No CV is available.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
    },
    deleteSavedSearch() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios.delete(`${API_URL}/save-search/${this.found}`).then((res) => {
        this.$bvToast.toast(res.data.msg, {
          title: `Message`,
          variant: `success`,
          solid: true,
        });
        this.reset();

        this.fetchSavedSearches();
      });
    },
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
  },
};
</script>
